module.exports = __webpack_public_path__ + "media/images/web/home/specs/spec_custom_2-436d48bb4a88683ee0582528019fb1c7.jpg";